function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

import React from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import LoginPageContainer from 'js/pages/auth/Login/Container';
import ResetPasswordPageContainer from 'js/pages/auth/ResetPassword/Container';
import SignupPageContainer from 'js/pages/auth/SignUp/Container';
import { LAT_LNG_DEFAULT as COUNTRY_MAP_LAT_LNG_DEFAULT, ZOOM_LEVEL_DEFAULT as COUNTRY_MAP_ZOOM_LEVEL_DEFAULT, ZOOM_POSITION as COUNTRY_MAP_ZOOM_POSITION } from 'json/search_map_config.json';
import { AUTH_ROUTE_PATH, AUTH_SIGNUP_ROUTE_PATH, AUTH_RESET_PASSWORD_ROUTE_PATH } from 'js/constants/routes';
import 'scss/auth_page.scss';
import Header from 'js/containers/organisms/Header';
import Footer from 'js/containers/organisms/Footer';

var AuthPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AuthPage, _React$Component);

  function AuthPage(props) {
    var _this;

    _classCallCheck(this, AuthPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AuthPage).call(this, props));
    _this.setView = _this.setView.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(AuthPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeMap();
    }
  }, {
    key: "setView",
    value: function setView() {
      var viewMap = {};
      viewMap[AUTH_ROUTE_PATH] = React.createElement(LoginPageContainer, {
        selectedPlan: this.props.plan
      });
      viewMap[AUTH_SIGNUP_ROUTE_PATH] = React.createElement(SignupPageContainer, null);
      viewMap[AUTH_RESET_PASSWORD_ROUTE_PATH] = React.createElement(ResetPasswordPageContainer, null);
      return viewMap[this.props.view];
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", null, React.createElement(Header, this.props), React.createElement("div", {
        ref: "countryMap",
        style: {
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 0
        }
      }), React.createElement("div", {
        style: {
          position: 'relative',
          marginTop: '95px'
        }
      }, React.createElement("div", {
        className: "country-search-content",
        style: {
          margin: 0,
          padding: '20px 40px'
        }
      }), React.createElement("div", {
        className: "auth-page-container"
      }, React.createElement("div", {
        className: "auth-page-container__content"
      }, this.setView()))), React.createElement(Footer, this.props));
    }
  }, {
    key: "initializeMap",
    value: function initializeMap() {
      var _this2 = this;

      this.setState({
        map: L.map(this.refs.countryMap).setView(COUNTRY_MAP_LAT_LNG_DEFAULT, COUNTRY_MAP_ZOOM_LEVEL_DEFAULT)
      }, function () {
        L.tileLayer('http://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png', {
          attribution: '©OpenStreetMap, ©CartoDB'
        }).addTo(_this2.state.map);

        _this2.state.map.zoomControl.setPosition(COUNTRY_MAP_ZOOM_POSITION);
      });
    }
  }]);

  return AuthPage;
}(React.Component);

AuthPage.propTypes = {
  children: PropTypes.any,
  isMobileWidth: PropTypes.bool.isRequired,
  view: PropTypes.any
};
export { AuthPage as default };